"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DEFAULT_ENVIRONMENT = void 0;
const DEFAULT_ENVIRONMENT = exports.DEFAULT_ENVIRONMENT = 'production';